import SkeletonLoaderUI, {
  SKELETON_LAYOUT,
  SKELETON_LOADER_TYPE,
} from '../skeletonLoaderUI/SkeletonLoaderUI';
import {
  addSearchTag,
  removeSearchTag,
  selectDefaultSearchTags,
  selectSearchTags,
  setDefaultSearchTags,
  setSearchByTags,
} from '../redux/slicers/search/searchSlicer';
import {
  addUpdateParamsInSequence,
  filterSelector,
  removeParamsInSequence,
  resetMembers,
  resetParamsInSequence,
  selectParamsInSequence,
  setMembers,
} from '../redux/slicers/filters/filterSlicer';
import {
  changeSideFilter,
  resetFilters,
  setDoFilterUpdateValue,
  sidebarSelector,
} from '../redux/slicers/admin/sidebarSlicer';
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FILTER } from '../components/admin/curator/CuratorFilter/CuratorFilter';
import { ScrollableTagList } from './ScrollableTagList/ScrollableTagList';
import _ from 'lodash';
import cx from 'classnames';
import { getUpdatedValueFromRemovedFiltersValue } from '../helpers/urlHelper';
import { paginatedTeamSelector } from '../redux/slicers/team/paginatedTeamSlicer';
import styles from './ScrollableTagList/ScrollableTagList.module.scss';
import { useCommonGlobalTags } from '../hooks/useCommonGlobalTags';
import { useUserContext } from '../contexts/UserContext';

const defaultLabels = {
  [FILTER.MY_FAVOURITES]: 'My Favourites',
  [FILTER.ARCHIVED]: 'Archived',
  [FILTER.GROUP_PROP]: 'Product Group',
  [FILTER.USER_MODEL_UPLOADED]: 'User Model',
  [FILTER.ALL_USER_PROPS]: 'All User Props',
  [FILTER.MATTRESS_BUILDER]: 'Mattress Builder'
};

export default function GlobalFilter({ designV2 }) {
  const dispatch = useDispatch();
  const paramsInSequence = useSelector(selectParamsInSequence);
  const { filtersData, filterValues } = useSelector(sidebarSelector);

  if (filterValues.length === 0 || !filtersData) return null;

  // create filter tags based on selected values
  const selectedFilterList = filterValues.map((value) => {
    let label = defaultLabels[value];

    if (!label && value?.startsWith('prop')) {
      const [, id] = value.split('_');
      label = filtersData?.props?.find((b) => b.id === parseInt(id))?.name;
    }

    if (!label && value?.startsWith('brand')) {
      const [, id] = value.split('_');
      label = filtersData?.brands?.find((b) => b.id === parseInt(id))?.name;
    }

    if (!label && value?.startsWith('collection_')) {
      const [, id] = value.split('_');
      label = filtersData?.collections?.find((c) => c.id === parseInt(id))?.name;
    }

    if (!label) {
      const option = filtersData?.filteroptions?.find(
        (option) => `option_${option.filter_label}_${option.id}` === value
      );
      label = option?.name;
    }
    window.$filterOptions = {
      ...(window.$filterOptions || {}),
      ...(label ? {[value]:label} : {})
    }
    if(!label){
      label = window.$filterOptions?.[value] || ""
    }
    return {
      value,
      label,
    };
  });

  const handleFilterClick = (value) => {
    if (value === 'favourite') {
      dispatch(removeParamsInSequence('is_favourite'));
    } else if (value === FILTER.GROUP_PROP) {
      dispatch(removeParamsInSequence('is_prop_group'));
    } else if (value === FILTER.USER_MODEL_UPLOADED) {
      dispatch(removeParamsInSequence('is_user_model_uploaded'));
    } else if (value === FILTER.ALL_USER_PROPS) {
      dispatch(removeParamsInSequence('assign_to_all_org'));
    } else if (value === 'archive') {
      dispatch(removeParamsInSequence('is_archive'));
    } else if (value === FILTER.MATTRESS_BUILDER) {
      dispatch(removeParamsInSequence('is_mattress_material'));
    } else {
      const { key, updatedVal } = getUpdatedValueFromRemovedFiltersValue(value, paramsInSequence);

      if (!updatedVal.length) {
        dispatch(removeParamsInSequence(key));
      } else {
        dispatch(addUpdateParamsInSequence({ [key]: updatedVal }));
      }
    }

    if (filterValues?.length <= 1) {
      dispatch(resetParamsInSequence('sidebarfilter'));
    }

    dispatch(changeSideFilter(value));
    dispatch(setDoFilterUpdateValue(true));
  };

  const handleResetGlobalFilter = () => {
    dispatch(resetParamsInSequence('sidebarfilter'));
    dispatch(resetFilters());
  };

  const settings = {
    arrows: true,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: false,
  };

  const scrollContainerId = `curatorFilter-${'filter'}`;
  return (
    <div className={`container-fluid px-0 ${designV2 ? 'tagListV2' : ''}`}>
      <div className={`${designV2 ? '' : 'pb-2'} header-name-of-my-projectbtns`}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="selectedGlobalFilter scl">
            <ScrollableTagList
              tagList={selectedFilterList}
              scrollContainerId={scrollContainerId}
              onDelete={handleFilterClick}
              className="selectedGlobalFilter"
              name="filter"
              containerProps={{ className: styles.sliderContainerGlobal }}
              prevBtnClassName={styles.prevButtonGlobal}
              nextBtnClassName={styles.nextButtonGlobal}
              itemClassName={styles.selectedFilterOuter}
              designV2={designV2}
            />
          </div>

          <button role="button" className="clrbtn" onClick={handleResetGlobalFilter}>
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
}

export const GlobalDefaultTeamMemberFilter = ({ model = '', designV2, showMe = null }) => {
  const dispatch = useDispatch();
  const selectedMembers = useSelector((state) => filterSelector(state)?.members);
  const memberList = useSelector(paginatedTeamSelector);
  const { currentUser } = useUserContext();
  const handleGetList = () => {
    if (selectedMembers?.length && memberList?.list?.length) {
      let list = [];
      memberList?.list?.map((team) => {
        if (selectedMembers.some(({ id }) => +id === +team?.id)) {
          list.push({
            value: team?.id,
            label:
              showMe && +currentUser?.id === +team?.id
                ? 'Me'
                : team?.user?.name || team?.user?.first_name,
          });
        }
      });
      window.$memberList = memberList;
      return list || [];
    } else {
      if (selectedMembers?.length && window?.$memberList?.list?.length) {
        let list = [];
        window?.$memberList?.list?.map((team) => {
          if (selectedMembers.some(({ id }) => +id === +team?.id)) {
            list.push({
              value: team?.id,
              label:
                showMe && +currentUser?.id === +team?.id
                  ? 'Me'
                  : team?.user?.name || team?.user?.first_name,
            });
          }
        });
        return list || [];
      } else {
        return [];
      }
    }
  };

  const handleFilterClick = (value) => {
    if (value) {
      const memberId = +value;
      const newValue = selectedMembers?.filter((m) => m?.id !== +memberId);
      if (!newValue?.length) {
        dispatch(resetMembers());
        dispatch(removeParamsInSequence('created_by'));
        dispatch(changeSideFilter());
        return;
      }
      dispatch(setMembers(newValue));
    }
  };

  const scrollContainerId = 'globalTeamMemberFilter';
  const selectedFilterList = handleGetList();
  return (
    <div className={`container-fluid px-0 tagListV2`}>
      <div className={`${designV2 ? '' : 'pt-2'} pb-0 header-name-of-my-projectbtns`}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="selectedGlobalFilter scl globalTagFilter">
            <ScrollableTagList
              tagList={selectedFilterList}
              scrollContainerId={scrollContainerId}
              onDelete={handleFilterClick}
              className="selectedGlobalFilter"
              name="filter"
              containerProps={{
                className: cx(
                  styles.sliderContainerGlobal,
                  styles.tagsFilter,
                  styles.globalTagFilter
                ),
              }}
              prevBtnClassName={styles.prevButtonGlobal}
              nextBtnClassName={styles.nextButtonGlobal}
              itemClassName={styles.selectedFilterOuter}
              designV2={designV2}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const GlobalDefaultSearchTagsFilter = memo(({ model = '' }) => {
  const dispatch = useDispatch();
  const searchTagsList = useSelector(selectSearchTags);
  const [loading, setLoading] = useState(true);

  const handleCallback = (tags) => {
    dispatch(setDefaultSearchTags(tags));
    setLoading(false);
  };

  useCommonGlobalTags({
    model,
    perPage: 5,
    callback: (tags) => handleCallback(tags),
  });

  const defaultTagsList = useSelector(selectDefaultSearchTags);

  if (loading)
    return (
      <SkeletonLoaderUI
        type={SKELETON_LOADER_TYPE.LIST}
        layout={SKELETON_LAYOUT.HORIZONTAL}
        count="5"
      />
    );

  if (!defaultTagsList.length) return null;

  const handleAddClick = (value) => {
    if (searchTagsList.includes(value)) return;

    dispatch(resetFilters());
    dispatch(addSearchTag(value));
    dispatch(addUpdateParamsInSequence({ tags: [...searchTagsList, value] }));
  };
  const handleFilterClick = (value) => {
    dispatch(resetFilters());
    dispatch(removeSearchTag(value));

    const filteredTags = searchTagsList.filter((a) => a !== value);
    if (!filteredTags.length) {
      dispatch(removeParamsInSequence('tags'));
      return;
    }
    dispatch(addUpdateParamsInSequence({ tags: filteredTags }));
  };

  const defaultTagsListWithSelectedState = defaultTagsList.map((t) => {
    return { ...t, selected: searchTagsList.includes(t.value) };
  });

  const scrollContainerId = 'globalDefaultSearchTagsFilter';
  return (
    <div className="p-0 header-name-of-my-projectbtns gap-1">
      <h6 className="ctag_title">Most Common Tags:</h6>
      <div className="d-flex align-items-center justify-content-between">
        <div className="selectedGlobalFilter scl globalTagFilter">
          <ScrollableTagList
            tagList={defaultTagsListWithSelectedState}
            scrollContainerId={scrollContainerId}
            selectable={true}
            onTagClick={handleAddClick}
            onDelete={handleFilterClick}
            className="selectedGlobalFilter"
            name="filter"
            containerProps={{
              className: cx(
                styles.sliderContainerGlobal,
                styles.tagsFilter,
                styles.globalCommonTagFilter
              ),
            }}
            prevBtnClassName={styles.prevButtonGlobal}
            nextBtnClassName={styles.nextButtonGlobal}
            itemClassName={styles.selectedFilterOuter}
          />
        </div>
      </div>
    </div>
  );
});

export const GlobalSearchTagsFilter = memo(({ designV2 }) => {
  const dispatch = useDispatch();
  const searchTagsList = useSelector(selectSearchTags);

  if (!searchTagsList.length) return null;

  const selectedFilterList = searchTagsList.map((a) => {
    return {
      label: a,
      value: a,
      default: false,
    };
  });

  const handleFilterClick = (value) => {
    const filteredTags = searchTagsList.filter((a) => a !== value);
    dispatch(setSearchByTags(filteredTags));

    if (!filteredTags.length) {
      dispatch(removeParamsInSequence('tags'));
      return;
    }
    dispatch(addUpdateParamsInSequence({ tags: filteredTags }));
  };

  const handleClearAll = () => {
    dispatch(setSearchByTags([]));
    dispatch(removeParamsInSequence('tags'));
  };

  const scrollContainerId = 'globalSearchTagsFilter';
  return (
    <div className={`container-fluid px-0 ${designV2 ? 'tagListV2' : ''}`}>
      <div className={`${designV2 ? '' : 'pt-2'} pb-0 header-name-of-my-projectbtns`}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="selectedGlobalFilter scl globalTagFilter">
            <ScrollableTagList
              tagList={selectedFilterList}
              scrollContainerId={scrollContainerId}
              onDelete={handleFilterClick}
              className="selectedGlobalFilter"
              name="filter"
              containerProps={{
                className: cx(
                  styles.sliderContainerGlobal,
                  styles.tagsFilter,
                  styles.globalTagFilter
                ),
              }}
              prevBtnClassName={styles.prevButtonGlobal}
              nextBtnClassName={styles.nextButtonGlobal}
              itemClassName={styles.selectedFilterOuter}
              designV2={designV2}
            />
          </div>
          {!designV2 && (
            <button role="button" className="clrbtn" onClick={handleClearAll}>
              Clear All
            </button>
          )}
        </div>
      </div>
    </div>
  );
});
